import $ from 'jquery';

var showExpander = function showExpander(uniq) {
  var $uniq = $(uniq);
  var $targetSelector = $($uniq.data('parent')).children('.show-more-expander');
  var $arrowChanger = $uniq.children('.control-arrow');
  var $showAllTextChanger = $uniq.children('span');

  if ($targetSelector.is(':hidden')) {
    $uniq.attr('data-ct-ignore', true);
    $targetSelector.slideDown();
    $arrowChanger.removeClass('right').addClass('up');
    $showAllTextChanger.html("".concat($uniq.attr('expanded-text')));
  } else {
    $uniq.removeAttr('data-ct-ignore');
    $targetSelector.slideUp();
    $arrowChanger.removeClass('up').addClass('right');
    $showAllTextChanger.html("".concat($uniq.attr('collapsed-text')));
  }
};

export var initShowExpander = function initShowExpander() {
  $('.expand-control-text').on('click', function (e) {
    e.preventDefault();
    showExpander(e.currentTarget);
  });
};
export default (function () {
  initShowExpander();
});